import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// Register service worker for PWA functionality
serviceWorkerRegistration.register({
  onSuccess: () => {
    console.log("PWA installed successfully");
  },
  onUpdate: (registration) => {
    console.log("New PWA version available");
    // You can show a notification to user here
    if (window.confirm("A new version is available. Update now?")) {
      serviceWorkerRegistration.forceUpdate();
    }
  },
});
